import axios from "@/http";

class OrderUpload {
  // 订单导入
  static postWMSOrderExcel(data) {
    const url = "/oa/api/upload/order";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default OrderUpload;